// @flow
import React from 'react';
import { fromNow, resizeImage } from 'lib/common';
import { Link } from 'react-router-dom';
import { MdLock } from 'react-icons/md';
import 'moment/locale/ko';
import cx from 'classnames';
import './PostCard.scss';

type Props = {
  id: string,
  thumbnail: string,
  username: string,
  displayName: string,
  title: string,
  body: string,
  price: string,
  supplier: string,
  date: string,
  urlSlug: string,
  userThumbnail: ?string,
  oneColumn?: boolean,
  commentsCount: number,
  hideUsername?: boolean,
  isPrivate: boolean,
  isTrending?: boolean,
};

const PostCard = ({
  thumbnail,
  username,
  displayName,
  title,
  body,
  date,
  urlSlug,
  userThumbnail,
  oneColumn,
  commentsCount,
  hideUsername,
  isPrivate,
  isTrending,
}: Props) => {
  const formattedDate = fromNow(date);
  const link = `/@${username}/${urlSlug}`;
  const imgUrl = resizeImage(thumbnail, 250, 150);
  const style = {
    backgroundImage: `url(${imgUrl})`,
  };
  return (
    <div
      className={cx('PostCard', {
        'one-column': oneColumn,
        empty: !thumbnail,
        'is-trending': isTrending,
        'is-not-trending': !isTrending,
      })}
    >
      <Link to={link} className={cx('thumbnail-wrapper')} style={style}>
        <div className="white-mask" />
      </Link>
      <div className="card-content">
        {!oneColumn && (
          <Link className="user-thumbnail-wrapper" to={`/@${username}/products`}>
            <img
              src={resizeImage(
                userThumbnail || 'https://images.cacheby.com/default_thumbnail.png',
                100,
                100,
              )}
              alt={username}
            />
          </Link>
        )}
        <Link to={link} className="content-head">
          <div className="between">
            {!hideUsername && <div className="username">{displayName}</div>}
            {isPrivate && (
              <div className="private">
                <MdLock />
                비공개
              </div>
            )}
          </div>
          <h3>
            <div>{title}</div>
          </h3>
          <div className="subinfo">
            <span>{formattedDate}</span>
            <span>{commentsCount}개의 댓글</span>
            <br />
          </div>
          <div className="description" style={{ WebkitBoxOrient: 'vertical' }}>
            {body}
          </div>
        </Link>
      </div>
    </div>
  );
};

PostCard.defaultProps = {
  oneColumn: false,
  hideUsername: false,
};

export default PostCard;



// WEBPACK FOOTER //
// ./src/components/common/PostCard/PostCard.js